import { styled } from 'styled-components';

import ChevronDownSVG from '../assets/chevron-down.svg?react';

export const ChevronDownIcon = styled(ChevronDownSVG)`
  width: 24px;
  height: 24px;
`;
